export enum DriverTabViewVariant {
  CONTACT_DETAILS = "contact-details",
  ADDITIONAL_DETAILS = "additional-details",
  PAYOUT_DETAILS = "payout-details",
}
